import DefaultLayout from "@/layouts/DefaultLayout";
import KServiceTypeForm from "kinnect-front/KService/KServiceTypeForm";
import { Crudable, FetchesData, Pageable } from "kinnect-mixins";
import { KActionDialog } from "kinnect-general";
import { ServiceType } from "kinnect-models";

export default {
	name: "ServiceTypePage",

	metaInfo() {
		const title = this.editing && this.fetched
			? `Service Center - Statuses - ${this.serviceType.name}`
			: "Service Center - Statuses - Add a Status";

		return { title: this.fetched ? title : null };
	},

	props: { idServiceType: Number },

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "service_types",
		deleteDialogOpen: false,
		serviceType: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idServiceType );
		},

		genDeleteDialog() {
			if ( this.editing && this.serviceType && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete service type" )}
					onConfirm={() => this.serviceType.delete()}
					redirect={[ "back", { name: "serviceTypes" } ]}
					title="Delete Service Status"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete the service status <strong>{this.serviceType.name}</strong>?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.editing && this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete Service Status",
					tooltip: "Delete this service status"
				};
			}
		}
	},

	methods: {
		async fetchServiceType() {
			if ( this.editing ) {
				this.serviceType = await ServiceType.findPageModel( this.idServiceType );
			}
		},

		async fetch() {
			await this.fetchServiceType();
		}
	},

	render() {
		return <DefaultLayout>
			<KServiceTypeForm
				loading={this.$wait.is( "find service type" )}
				readonly={this.editing ? !this.canEdit : !this.canAdd}
				serviceType={this.serviceType}
			></KServiceTypeForm>

			{this.genDeleteDialog}
		</DefaultLayout>;
	}
};
